import "./Register.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import FormImage from "../../Assets/images/login.png";
import RegisterViewModel from "./RegisterViewModel";
import { ToastContainer } from "react-toastify";
import "react-phone-number-input/style.css";
import ButtonSpinner from "../../Components/Spinners/ButtonSpinner";
import ValidateStudentRegistrationNo from "../../Controllers/Auth/ValidateStudentRegistrationNo";
import {
  ToastInfoMessages,
  ToastWarnMessages,
} from "../../Helpers/ToastMessages";
import PhoneInput from "react-phone-number-input";
import { PatternFormat } from "react-number-format";
import ReactSelect from "../../Components/Select/React-Select";
import Select from "react-select";

const Register = () => {
  const [
    User,
    setUser,
    AdminAdditionalDetails,
    setAdminAdditionalDetails,
    TeacherAdditionalDetails,
    setTeacherAdditionalDetails,
    StudentAdditionalDetails,
    setStudentAdditionalDetails,
    ParentAdditionalDetails,
    setParentAdditionalDetails,
    RegisterUser,
    CnicNumber,
    HandleCNICFormat,
    FirstNameError,
    LastNameError,
    GenderError,
    EmailError,
    UserTypeError,
    PasswordError,
    ConfirmPasswordError,
    AdminCNICError,
    AdminPhoneNoError,
    AdminDesignationError,
    TeacherCNICError,
    TeacherPhoneNoError,
    TeacherSchoolNameError,
    TeacherEmployeeIDError,
    StudentSchoolNameError,
    StudentRegistrationNoError,
    StudentClassError,
    ParentCNICError,
    ParentPhoneNoError,
    ParentSchoolNameError,
    ParentStudentRegistrationNoError,
    FormDisabled,
    SchoolClasses,
    ButtonLoader,
    setButtonLoader,
    SchoolID,
    ActiveIndex,
    setActiveIndex,
    ChildrenIDs,
    setChildrenIDs,
    StudentRegistrationNo,
    setStudentRegistrationNo,
    IsCheckError,
    TotalSchools,
    setSchoolID,
  ] = RegisterViewModel();

  return (
    <Fragment>
      <div className="main-wrapper register-body">
        <div className="register-wrapper">
          <div className="container">
            <div className="registerbox">
              <div className="register-left">
                <img className="img-fluid" src={FormImage} alt="Logo" />
              </div>
              <div className="register-right">
                <div className="register-right-wrap">
                  <h1>Sign Up</h1>
                  <p className="account-subtitle">
                    Enter details to create your account
                  </p>
                  {/* Form */}
                  <form className="user-register-form">
                    <div className="row">
                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>
                            First Name{" "}
                            <span className="register-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              FirstNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setUser({ ...User, FirstName: e.target.value });
                            }}
                            disabled={FormDisabled}
                          />
                          {FirstNameError === true ? (
                            <span className="register-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                First name is required and cannot be less than 3
                                characters
                              </span>
                            </span>
                          ) : (
                            <span className="register-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="register-tooltip-text">
                                First name is required and cannot be less than 3
                                characters
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>
                            Last Name <span className="register-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              LastNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setUser({ ...User, LastName: e.target.value });
                            }}
                            disabled={FormDisabled}
                          />
                          {LastNameError === true ? (
                            <span className="register-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                First name is required and cannot be less than 3
                                characters
                              </span>
                            </span>
                          ) : (
                            <span className="register-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="register-tooltip-text">
                                Last name is required and cannot be less than 3
                                characters
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>
                            Gender <span className="register-danger">*</span>
                          </label>
                          <ReactSelect
                            error={GenderError === true ? true : false}
                            handleChange={(value) => {
                              setUser({ ...User, Gender: value });
                            }}
                            disabled={FormDisabled}
                            options={[
                              {
                                value: "Select Gender",
                                label: "Select Gender",
                                isDisabled: true,
                              },
                              {
                                value: "male",
                                label: "Male",
                              },
                              {
                                value: "female",
                                label: "Female",
                              },
                              {
                                value: "other",
                                label: "Other",
                              },
                            ]}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>
                            Email <span className="register-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control ${
                              EmailError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setUser({ ...User, Email: e.target.value });
                            }}
                            disabled={FormDisabled}
                          />
                          {EmailError === true ? (
                            <span className="register-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Email is required. xyz@gmail.com
                              </span>
                            </span>
                          ) : (
                            <span className="register-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="register-tooltip-text">
                                Email is required. xyz@gmail.com
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group">
                        <label>
                          Type <span className="register-danger">*</span>
                        </label>
                        <ReactSelect
                          error={UserTypeError === true ? true : false}
                          handleChange={(value) => {
                            setUser({ ...User, UserType: value });
                          }}
                          disabled={FormDisabled}
                          options={[
                            {
                              value: "Select User Type",
                              label: "Select User Type",
                              isDisabled: true,
                            },
                            {
                              value: "admin",
                              label: "Admin",
                            },
                            {
                              value: "teacher",
                              label: "Teacher",
                            },
                            {
                              value: "student",
                              label: "Student",
                            },
                            {
                              value: "parent",
                              label: "Parent",
                            },
                          ]}
                        />
                      </div>
                      {User.UserType === "admin" ? (
                        <Fragment>
                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                CNIC <span className="register-danger">*</span>
                              </label>
                              <PatternFormat
                                allowEmptyFormatting
                                format="#####-#######-#"
                                placeholder="#####-#######-#"
                                className={`form-control ${
                                  AdminCNICError === true && "error-message"
                                }`}
                                onChange={(e) => {
                                  setAdminAdditionalDetails({
                                    ...AdminAdditionalDetails,
                                    CNIC: e.target.value,
                                  });
                                }}
                                disabled={FormDisabled}
                              />

                              {AdminCNICError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    CNIC is required. 1530256784568
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    CNIC is required. 1530256784568
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                Phone No{" "}
                                <span className="register-danger">*</span>
                              </label>
                              <PhoneInput
                                country="PK"
                                addInternationalOption={true}
                                defaultCountry="PK"
                                className={`form-control phone-input ${
                                  AdminPhoneNoError === true && "error-message"
                                }`}
                                countryCallingCodeEditable={true}
                                initialValueFormat="national"
                                onChange={(value) => {
                                  setAdminAdditionalDetails({
                                    ...AdminAdditionalDetails,
                                    PhoneNo: value,
                                  });
                                }}
                                disabled={FormDisabled}
                              />

                              {AdminPhoneNoError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    Phone no is required. 03068943617
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    Phone no is required. 03068943617
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="form-group">
                              <label>
                                Designation{" "}
                                <span className="register-danger">*</span>
                              </label>

                              <ReactSelect
                                error={
                                  AdminDesignationError === true ? true : false
                                }
                                handleChange={(value) => {
                                  setAdminAdditionalDetails({
                                    ...AdminAdditionalDetails,
                                    Designation: value,
                                  });
                                }}
                                disabled={FormDisabled}
                                options={[
                                  {
                                    value: "Select Admin Designation",
                                    label: "Select Admin Designation",
                                    isDisabled: true,
                                  },
                                  {
                                    value: "principal",
                                    label: "Principal",
                                  },
                                  {
                                    value: "vice principal",
                                    label: "Vice Principal",
                                  },
                                  {
                                    value: "chairman",
                                    label: "Chairman",
                                  },
                                ]}
                              />
                            </div>
                          </div>
                        </Fragment>
                      ) : User.UserType === "teacher" ? (
                        <Fragment>
                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                CNIC <span className="register-danger">*</span>
                              </label>
                              <PatternFormat
                                allowEmptyFormatting
                                format="#####-#######-#"
                                placeholder="#####-#######-#"
                                className={`form-control ${
                                  TeacherCNICError === true && "error-message"
                                }`}
                                onChange={(e) => {
                                  setTeacherAdditionalDetails({
                                    ...TeacherAdditionalDetails,
                                    CNIC: e.target.value,
                                  });
                                }}
                                disabled={FormDisabled}
                              />
                              {/* <input
                                type="number"
                                className={`form-control ${
                                  TeacherCNICError === true && "error-message"
                                }`}
                                onChange={(e) => {
                                  HandleCNICFormat(e);
                                  setTeacherAdditionalDetails({
                                    ...TeacherAdditionalDetails,
                                    CNIC: e.target.value,
                                  });
                                }}
                                value={CnicNumber}
                                disabled={FormDisabled}
                              /> */}
                              {TeacherCNICError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    CNIC is required. 1530256784568
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    CNIC is required. 1530256784568
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                Phone No{" "}
                                <span className="register-danger">*</span>
                              </label>
                              <PhoneInput
                                country="PK"
                                addInternationalOption={false}
                                defaultCountry="PK"
                                className={`form-control phone-input ${
                                  TeacherPhoneNoError === true &&
                                  "error-message"
                                }`}
                                countryCallingCodeEditable={false}
                                initialValueFormat="national"
                                onChange={(value) => {
                                  setTeacherAdditionalDetails({
                                    ...TeacherAdditionalDetails,
                                    PhoneNo: value,
                                  });
                                }}
                                disabled={FormDisabled}
                              />

                              {TeacherPhoneNoError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    Phone no is required. 03068943617
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    Phone no is required. 03068943617
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>

                          {/* <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                School Name{" "}
                                <span className="register-danger">*</span>
                              </label>
                              <input
                                className={`form-control ${
                                  TeacherSchoolNameError === true &&
                                  "error-message"
                                }`}
                                type="text"
                                onChange={(e) => {
                                  setTeacherAdditionalDetails({
                                    ...TeacherAdditionalDetails,
                                    SchoolName: e.target.value.toLowerCase(),
                                  });
                                }}
                                disabled={FormDisabled}
                              />
                              {TeacherSchoolNameError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              )}
                            </div>
                          </div> */}

                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                School Name{" "}
                                <span className="register-danger">*</span>
                              </label>
                              <ReactSelect
                                error={
                                  TeacherSchoolNameError === true ? true : false
                                }
                                handleChange={(value, label) => {
                                  setSchoolID(value);
                                  setTeacherAdditionalDetails({
                                    ...TeacherAdditionalDetails,
                                    SchoolName: label.toLowerCase(),
                                  });
                                }}
                                disabled={FormDisabled}
                                options={[
                                  {
                                    value: "Select School",
                                    label: "Select School",
                                    isDisabled: true,
                                  },
                                  ...TotalSchools,
                                ]}
                              />
                              {/* {TeacherSchoolNameError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              )} */}
                            </div>
                          </div>

                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                Employee ID{" "}
                                <span className="register-danger">*</span>
                              </label>
                              <input
                                className={`form-control ${
                                  TeacherEmployeeIDError === true &&
                                  "error-message"
                                }`}
                                type="text"
                                onChange={(e) => {
                                  setTeacherAdditionalDetails({
                                    ...TeacherAdditionalDetails,
                                    EmployeeID: e.target.value,
                                  });
                                }}
                                disabled={FormDisabled}
                              />
                              {TeacherEmployeeIDError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    Teacher employment ID is required
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    Teacher employment ID is required
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>
                        </Fragment>
                      ) : User.UserType === "student" ? (
                        <Fragment>
                          {/* <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                School Name{" "}
                                <span className="register-danger">*</span>
                              </label>
                              <input
                                className={`form-control ${
                                  StudentSchoolNameError === true &&
                                  "error-message"
                                }`}
                                type="text"
                                onChange={(e) => {
                                  setStudentAdditionalDetails({
                                    ...StudentAdditionalDetails,
                                    SchoolName: e.target.value.toLowerCase(),
                                  });
                                }}
                                disabled={FormDisabled}
                              />
                              {StudentSchoolNameError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              )}
                            </div>
                          </div> */}

                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                School Name{" "}
                                <span className="register-danger">*</span>
                              </label>
                              <ReactSelect
                                error={
                                  StudentSchoolNameError === true ? true : false
                                }
                                handleChange={(value, label) => {
                                  setSchoolID(value);
                                  setStudentAdditionalDetails({
                                    ...StudentAdditionalDetails,
                                    SchoolName: label.toLowerCase(),
                                  });
                                }}
                                disabled={FormDisabled}
                                options={[
                                  {
                                    value: "Select School",
                                    label: "Select School",
                                    isDisabled: true,
                                  },
                                  ...TotalSchools,
                                ]}
                              />
                              {/* {StudentSchoolNameError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              )} */}
                            </div>
                          </div>

                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                Student Registration No{" "}
                                <span className="register-danger">*</span>
                              </label>
                              <input
                                className={`form-control ${
                                  StudentRegistrationNoError === true &&
                                  "error-message"
                                }`}
                                type="text"
                                onChange={(e) => {
                                  setStudentAdditionalDetails({
                                    ...StudentAdditionalDetails,
                                    StudentRegistrationNo: e.target.value,
                                  });
                                }}
                                disabled={FormDisabled}
                              />
                              {StudentRegistrationNoError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    Student registration no is required
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    Student registration no is required
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>

                          {SchoolClasses && SchoolClasses?.length !== 0 && (
                            <div className="form-group">
                              <label>
                                Class <span className="register-danger">*</span>
                              </label>
                              <ReactSelect
                                error={
                                  StudentClassError === true ? true : false
                                }
                                handleChange={(value) => {
                                  setStudentAdditionalDetails({
                                    ...StudentAdditionalDetails,
                                    ClassID: value,
                                  });
                                }}
                                disabled={FormDisabled}
                                options={[
                                  {
                                    value: "Select Class",
                                    label: "Select Class",
                                    isDisabled: true,
                                  },
                                  ...SchoolClasses?.map((item) => ({
                                    value: item.id,
                                    label: item?.className,
                                  })),
                                ]}
                              />
                            </div>
                          )}
                        </Fragment>
                      ) : User.UserType === "parent" ? (
                        <Fragment>
                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                CNIC <span className="register-danger">*</span>
                              </label>
                              <PatternFormat
                                allowEmptyFormatting
                                format="#####-#######-#"
                                placeholder="#####-#######-#"
                                className={`form-control ${
                                  ParentCNICError === true && "error-message"
                                }`}
                                onChange={(e) => {
                                  setParentAdditionalDetails({
                                    ...ParentAdditionalDetails,
                                    CNIC: e.target.value,
                                  });
                                }}
                                disabled={FormDisabled}
                              />

                              {ParentCNICError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    CNIC is required. 1530256784568
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    CNIC is required. 1530256784568
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>

                          <div className=" col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                Phone No{" "}
                                <span className="register-danger">*</span>
                              </label>
                              <PhoneInput
                                country="PK"
                                addInternationalOption={false}
                                defaultCountry="PK"
                                className={`form-control phone-input ${
                                  ParentPhoneNoError === true && "error-message"
                                }`}
                                countryCallingCodeEditable={false}
                                initialValueFormat="national"
                                onChange={(value) => {
                                  setParentAdditionalDetails({
                                    ...ParentAdditionalDetails,
                                    PhoneNo: value,
                                  });
                                }}
                                disabled={FormDisabled}
                              />
                              {/* <input
                              
                                type="text"
                                onChange={(e) => {
                                  setParentAdditionalDetails({
                                    ...ParentAdditionalDetails,
                                    PhoneNo: e.target.value,
                                  });
                                }}
                                disabled={FormDisabled}
                              /> */}
                              {ParentPhoneNoError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    Phone no is required. 03068943617
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    Phone no is required. 03068943617
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>

                          {/* <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                School Name(URL){" "}
                                <span className="register-danger">*</span>
                              </label>
                              <input
                                className={`form-control ${
                                  ParentSchoolNameError === true &&
                                  "error-message"
                                }`}
                                type="text"
                                onChange={(e) => {
                                  setParentAdditionalDetails({
                                    ...ParentAdditionalDetails,
                                    SchoolName: e.target.value.toLowerCase(),
                                  });
                                }}
                                disabled={FormDisabled}
                              />
                              {ParentSchoolNameError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              )}
                            </div>
                          </div> */}

                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label>
                                School Name
                                <span className="register-danger">*</span>
                              </label>
                              <ReactSelect
                                error={
                                  ParentSchoolNameError === true ? true : false
                                }
                                handleChange={(value, label) => {
                                  setSchoolID(value);
                                  setParentAdditionalDetails({
                                    ...ParentAdditionalDetails,
                                    SchoolName: label.toLowerCase(),
                                  });
                                }}
                                disabled={FormDisabled}
                                options={[
                                  {
                                    value: "Select School",
                                    label: "Select School",
                                    isDisabled: true,
                                  },
                                  ...TotalSchools,
                                ]}
                              />
                              {/* {ParentSchoolNameError === true ? (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info icon-after-submit"></i>
                                  <span className="text-after-submit">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              ) : (
                                <span className="register-tooltip">
                                  <i className="fa-solid fa-info text-info"></i>
                                  <span className="register-tooltip-text">
                                    School name is required and cannot be less
                                    than 3 characters
                                  </span>
                                </span>
                              )} */}
                            </div>
                          </div>

                          {StudentRegistrationNo.map((item, index) => {
                            return (
                              <div
                                className="row"
                                key={index}
                                style={{
                                  margin: 0,
                                  padding: 0,
                                }}
                              >
                                <div className="col-10">
                                  <div className="form-group">
                                    <label>
                                      Student Registration No{" "}
                                      <span className="register-danger">*</span>
                                    </label>
                                    <input
                                      className={`form-control ${
                                        IsCheckError &&
                                        (item.RegNo === "" ||
                                          item.IsValid === false) &&
                                        "error-message"
                                      }`}
                                      type="text"
                                      onChange={(e) => {
                                        let temp = StudentRegistrationNo;
                                        temp[index].RegNo = e.target.value;
                                        setStudentRegistrationNo([...temp]);
                                      }}
                                      disabled={
                                        FormDisabled || index < ActiveIndex
                                      }
                                      onBlur={async (e) => {
                                        let resp =
                                          await ValidateStudentRegistrationNo(
                                            e.target.value,
                                            SchoolID
                                          );
                                        if (resp.size !== 0) {
                                          let temp = StudentRegistrationNo;
                                          temp[ActiveIndex].StudentId = resp.id;
                                          temp[ActiveIndex].IsValid = true;
                                          setStudentRegistrationNo([...temp]);
                                        }
                                        if (resp.size === 0 && resp.id === "") {
                                          let temp = StudentRegistrationNo;
                                          temp[ActiveIndex].StudentId = resp.id;
                                          temp[ActiveIndex].IsValid = false;
                                          setStudentRegistrationNo([...temp]);
                                        }
                                      }}
                                    />
                                    {IsCheckError &&
                                    (item.RegNo === "" ||
                                      item.IsValid === false) ? (
                                      <span className="register-tooltip">
                                        <i className="fa-solid fa-info icon-after-submit"></i>
                                        <span className="text-after-submit">
                                          Student registration no is required
                                        </span>
                                      </span>
                                    ) : (
                                      <span className="register-tooltip">
                                        <i className="fa-solid fa-info text-info"></i>
                                        <span className="register-tooltip-text">
                                          Student registration no is required
                                        </span>
                                      </span>
                                    )}
                                  </div>
                                </div>

                                <div className="col-2">
                                  {index + 1 == 1 && (
                                    <button
                                      type="button"
                                      className="add-student-id-button"
                                      onClick={async () => {
                                        if (SchoolID === "") {
                                          ToastInfoMessages("school/first");
                                          return;
                                        }

                                        if (
                                          StudentRegistrationNo[index].RegNo ===
                                          ""
                                        ) {
                                          ToastWarnMessages(
                                            "invalid/registration-number"
                                          );

                                          return;
                                        }
                                        let resp =
                                          await ValidateStudentRegistrationNo(
                                            StudentRegistrationNo[ActiveIndex]
                                              .RegNo,
                                            SchoolID
                                          );
                                        if (resp.size === 0) {
                                          ToastWarnMessages(
                                            "invalid/registration-number"
                                          );
                                          let temp = StudentRegistrationNo;
                                          temp[ActiveIndex].StudentId = resp.id;
                                          setStudentRegistrationNo([...temp]);
                                          return;
                                        } else {
                                          let temp = StudentRegistrationNo;
                                          temp[ActiveIndex].StudentId = resp.id;
                                          temp[ActiveIndex].IsValid = true;
                                          temp.push({
                                            RegNo: "",
                                            StudentId: "",
                                            IsValid: false,
                                          });
                                          setStudentRegistrationNo([...temp]);
                                          setActiveIndex(ActiveIndex + 1);
                                        }
                                      }}
                                    >
                                      +
                                    </button>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </Fragment>
                      ) : (
                        ""
                      )}

                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>
                            Password <span className="register-danger">*</span>
                          </label>
                          <input
                            // className="form-control pass-input"
                            className={`form-control ${
                              PasswordError === true && "error-message"
                            }`}
                            type="password"
                            onChange={(e) => {
                              setUser({ ...User, Password: e.target.value });
                            }}
                            disabled={FormDisabled}
                          />
                          {PasswordError === true ? (
                            <a href="#" className="register-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Password is required and cannot be less than 6
                                characters
                              </span>
                            </a>
                          ) : (
                            <a href="#" className="register-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="register-tooltip-text">
                                Password is required and cannot be less than 6
                                characters
                              </span>
                            </a>
                          )}
                          {/* <span className="profile-views feather-eye toggle-password" /> */}
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>
                            Confirm password{" "}
                            <span className="register-danger">*</span>
                          </label>
                          <input
                            // className="form-control pass-confirm"
                            className={`form-control ${
                              ConfirmPasswordError === true && "error-message"
                            }`}
                            type="password"
                            onChange={(e) => {
                              setUser({
                                ...User,
                                ConfirmPassword: e.target.value,
                              });
                            }}
                            disabled={FormDisabled}
                          />
                          {ConfirmPasswordError === true ? (
                            <a href="#" className="register-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Passwords should match
                              </span>
                            </a>
                          ) : (
                            <a href="#" className="register-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="register-tooltip-text">
                                Passwords should match
                              </span>
                            </a>
                          )}
                          {/* <span className="profile-views feather-eye reg-toggle-password" /> */}
                        </div>
                      </div>
                      <div className=" dont-have">
                        Already Registered? <Link to="/login">Login</Link>
                      </div>
                      <div className="form-group mb-0">
                        <button
                          className="btn btn-primary btn-block
                          form-submit-btn-flex
                          "
                          type="button"
                          onClick={() => {
                            RegisterUser();
                          }}
                          disabled={FormDisabled}
                        >
                          {ButtonLoader && <ButtonSpinner />}
                          &nbsp; Register
                        </button>
                      </div>
                    </div>
                  </form>
                  {/* /Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </Fragment>
  );
};

export default Register;
